import { useEffect, useState } from "react";
import type { Preferences } from "../types";

const KEY = "newslens.preferences.v1";
const DEFAULTS: Preferences = { schemaVersion: 1, categories: ["US", "World", "Business", "Technology", "Science"], largeText: false, reduceMotion: false, savedStoryIds: [] };

function readPreferences(): Preferences {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) ?? "null") as Partial<Preferences> | null;
    return parsed?.schemaVersion === 1 ? { ...DEFAULTS, ...parsed } : DEFAULTS;
  } catch { return DEFAULTS; }
}

export function usePreferences() {
  const [preferences, setPreferences] = useState<Preferences>(() => readPreferences());
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(preferences)); }, [preferences]);
  const toggleSaved = (storyId: string) => setPreferences((current) => ({
    ...current,
    savedStoryIds: current.savedStoryIds.includes(storyId) ? current.savedStoryIds.filter((id) => id !== storyId) : [...current.savedStoryIds, storyId],
  }));
  return { preferences, setPreferences, toggleSaved };
}
